import Grid from "@mui/material/Grid";
import {Checkbox, FormControlLabel, FormHelperText, InputLabel, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {Add} from "@mui/icons-material";
import * as React from "react";

export default function NewsForm({fields, errors, handleChange, handleBlur, handleSubmit}) {
    return <React.Fragment>
        <Grid container spacing={2}
              component="form"
              onSubmit={handleSubmit}
              autoComplete="off"
        >
            <Grid size={{ xs: 12 }}>
                <InputLabel>Title</InputLabel>
                <TextField
                    error={!!errors.title}
                    value={fields.title || ""}
                    name="title"
                    id="title"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter news title"
                />
                {errors.title && <FormHelperText>{errors.title}</FormHelperText>}
            </Grid>
            <Grid size={{ xs: 12 }}>
                <InputLabel>Content</InputLabel>
                <TextField
                    error={!!errors.content}
                    value={fields.content || ""}
                    name="content"
                    id="content"
                    required={true}
                    fullWidth={true}
                    multiline
                    rows={8}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter news content"
                />
                {errors.content && <FormHelperText>{errors.content}</FormHelperText>}
            </Grid>
            <Grid size={12}>
                <FormControlLabel
                    control={
                        <Checkbox
                            name="enabled"
                            checked={typeof fields.enabled === 'boolean' ? fields.enabled : true}
                            onChange={handleChange}
                            value={typeof fields.enabled === 'boolean' ? fields.enabled : true}
                            color="primary"
                        />
                    }
                    label="Enabled"
                />
            </Grid>
            <Grid container spacing={3} sx={{mt: 2}} size={12}>
                <Grid size={{ xs: 6 }}>
                    <Button type="submit" onClick={handleSubmit} variant="outlined" startIcon={<Add />} >
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    </React.Fragment>
}

